export default "__VITE_PUBLIC_ASSET__f0f78a35__"